import Swiper from 'swiper';
import { Navigation, Pagination, Autoplay } from 'swiper';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import '../css/tailwind/config.css';

document.addEventListener('DOMContentLoaded', () => {
  const swiper = new Swiper('.swiper-feature', {
    modules: [Navigation, Pagination, Autoplay],
    loop: true,
    autoplay: {
      delay: 8000, // 3秒ごとに自動再生
      disableOnInteraction: false,
    },
    centeredSlides: true,
    slidesPerView: 1,
    spaceBetween: 10,
    speed: 1000,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
  });

  // ボタンのクリックで停止/再生を切り替え
  const toggleBtn = document.getElementById('swiper-toggle');
  if (toggleBtn) {
    const pauseIcon = toggleBtn.querySelector('.icon-pause');
    const playIcon = toggleBtn.querySelector('.icon-play');

    let isPlaying = true;

    toggleBtn.addEventListener('click', () => {
      if (isPlaying) {
        swiper.autoplay.stop();
        if (pauseIcon && playIcon) {
          pauseIcon.classList.add('hidden');
          playIcon.classList.remove('hidden');
        }
      } else {
        swiper.autoplay.start();
        if (pauseIcon && playIcon) {
          playIcon.classList.add('hidden');
          pauseIcon.classList.remove('hidden');
        }
      }
      isPlaying = !isPlaying;
    });
  }

  const swiper_ptn = new Swiper('.swiper-ptn', {
    modules: [Navigation, Pagination, Autoplay],
    loop: true,
    centeredSlides: true,
    slidesPerView: 1,
    spaceBetween: 10,
    speed: 1000,
    navigation: {
      nextEl: '.ptn-button-next',
      prevEl: '.ptn-button-prev',
    },
    pagination: {
      el: '.swiper-ptn-pagination',
      clickable: true,
    },
  });

  // ボタンのクリックで停止/再生を切り替え
  if (toggleBtn) {
    const pauseIcon = toggleBtn.querySelector('.icon-pause');
    const playIcon = toggleBtn.querySelector('.icon-play');

    let isPlaying = true;

    toggleBtn.addEventListener('click', () => {
      if (isPlaying) {
        swiper_ptn.autoplay.stop();
        if (pauseIcon && playIcon) {
          pauseIcon.classList.add('hidden');
          playIcon.classList.remove('hidden');
        }
      } else {
        swiper_ptn.autoplay.start();
        if (pauseIcon && playIcon) {
          playIcon.classList.add('hidden');
          pauseIcon.classList.remove('hidden');
        }
      }
      isPlaying = !isPlaying;
    });
  }

  const swiper_spot = new Swiper('.swiper-spot', {
    modules: [Navigation, Pagination, Autoplay],
    loop: true,
    autoplay: {
      delay: 8000, // 3秒ごとに自動再生
      disableOnInteraction: false,
    },
    centeredSlides: true,
    slidesPerView: 1,
    spaceBetween: 20,
    speed: 1000,
    navigation: {
      nextEl: '.spot-button-next',
      prevEl: '.spot-button-prev',
    },
    pagination: {
      el: '.swiper-spot-pagination',
      clickable: true,
    },
    breakpoints: {
      // 640px以上のとき
      768: {
        slidesPerView: 1.3,
        spaceBetween: 20,
      },
    },
  });

  // ボタンのクリックで停止/再生を切り替え
  if (toggleBtn) {
    const pauseIcon = toggleBtn.querySelector('.icon-pause');
    const playIcon = toggleBtn.querySelector('.icon-play');

    let isPlaying = true;

    toggleBtn.addEventListener('click', () => {
      if (isPlaying) {
        swiper_spot.autoplay.stop();
        if (pauseIcon && playIcon) {
          pauseIcon.classList.add('hidden');
          playIcon.classList.remove('hidden');
        }
      } else {
        swiper_spot.autoplay.start();
        if (pauseIcon && playIcon) {
          playIcon.classList.add('hidden');
          pauseIcon.classList.remove('hidden');
        }
      }
      isPlaying = !isPlaying;
    });
  }

  const swiper_near_spot = new Swiper('.swiper-near-spots', {
    modules: [Navigation, Pagination, Autoplay],
    loop: false,
    // autoplay: {
    //   delay: 8000, // 3秒ごとに自動再生
    //   disableOnInteraction: false,
    // },
    centeredSlides: false,
    slidesPerView: 1,
    spaceBetween: 15,
    speed: 1000,
    navigation: {
      nextEl: '.swiper-near-spots-button-next',
      prevEl: '.swiper-near-spots-button-prev',
    },
    pagination: {
      el: '.swiper-near-spots-pagination',
      clickable: true,
    },
    breakpoints: {
      // 640px以上のとき
      768: {
        slidesPerView: 3,
        spaceBetween: 20,
      },
    },
  });

  const swiper_highlight_spots = new Swiper('.swiper-highlight-spots', {
    modules: [Navigation, Pagination, Autoplay],
    loop: false,
    autoplay: {
      delay: 8000, // 3秒ごとに自動再生
      disableOnInteraction: false,
    },
    centeredSlides: false,
    slidesPerView: 1.5,
    spaceBetween: 15,
    speed: 1000,
    navigation: {
      nextEl: '.swiper-highlight-spots-button-next',
      prevEl: '.swiper-highlight-spots-button-prev',
    },
    pagination: {
      el: '.swiper-highlight-spots-pagination',
      clickable: true,
    },
    breakpoints: {
      // 640px以上のとき
      768: {
        slidesPerView: 4,
        spaceBetween: 20,
      },
    },
  });

  const swiper_top_mv = new Swiper('.swiper-top-mv', {
    modules: [Navigation, Pagination, Autoplay],
    loop: true,
    autoplay: {
      delay: 8000, // 5秒ごとに自動再生
      disableOnInteraction: false,
    },
    centeredSlides: true,
    slidesPerView: 1,
    spaceBetween: 0,
    speed: 2000,
    pagination: {
      el: '.swiper-top-mv-pagination',
      clickable: true,
    },
    breakpoints: {
      // 640px以上のとき
      768: {
        slidesPerView: 1.5,
      },
    },
  });

  // ボタンのクリックで停止/再生を切り替え
  if (toggleBtn) {
    const pauseIcon = toggleBtn.querySelector('.icon-pause');
    const playIcon = toggleBtn.querySelector('.icon-play');

    let isPlaying = true;

    toggleBtn.addEventListener('click', () => {
      if (isPlaying) {
        swiper_top_mv.autoplay.stop();
        if (pauseIcon && playIcon) {
          pauseIcon.classList.add('hidden');
          playIcon.classList.remove('hidden');
        }
      } else {
        swiper_top_mv.autoplay.start();
        if (pauseIcon && playIcon) {
          playIcon.classList.add('hidden');
          pauseIcon.classList.remove('hidden');
        }
      }
      isPlaying = !isPlaying;
    });
  }

  const swiper_top_event = new Swiper('.swiper-top-event', {
    modules: [Navigation, Pagination, Autoplay],
    loop: true,
    autoplay: {
      delay: 5000, // 5秒ごとに自動再生
      disableOnInteraction: false,
    },
    centeredSlides: false,
    slidesPerView: 2,
    spaceBetween: 40,
    speed: 1000,
    navigation: {
      nextEl: '.top-event-button-next',
      prevEl: '.top-event-button-prev',
    },
    pagination: {
      el: '.swiper-top-event-pagination',
      clickable: true,
    },
    breakpoints: {
      // 640px以上のとき
      768: {
        slidesPerView: 3,
      },
    },
  });

  const swiper_top_course = new Swiper('.swiper-top-course', {
    modules: [Navigation, Pagination, Autoplay],
    loop: true,
    autoplay: {
      delay: 5000, // 5秒ごとに自動再生
      disableOnInteraction: false,
    },
    centeredSlides: true,
    slidesPerView: 2,
    spaceBetween: 40,
    speed: 1000,
    navigation: {
      nextEl: '.top-course-button-next',
      prevEl: '.top-course-button-prev',
    },
    pagination: {
      el: '.swiper-top-course-pagination',
      clickable: true,
    },
    breakpoints: {
      // 640px以上のとき
      768: {
        slidesPerView: 3.3,
      },
    },
  });

  const swiper_event = new Swiper('.swiper-event', {
    modules: [Navigation, Pagination, Autoplay],
    loop: true,
    autoplay: {
      delay: 8000, // 3秒ごとに自動再生
      disableOnInteraction: false,
    },
    centeredSlides: true,
    slidesPerView: 1,
    spaceBetween: 15,
    speed: 1000,
    navigation: {
      nextEl: '.swiper-event-button-next',
      prevEl: '.swiper-event-button-prev',
    },
    pagination: {
      el: '.swiper-event-pagination',
      clickable: true,
    },
    breakpoints: {
      // 640px以上のとき
      768: {
        slidesPerView: 1.3,
        spaceBetween: 20,
      },
    },
  });
});
